export const AI_ROUTES = {
	CHAT: "/ai",
} as const;
